import { useEffect, useState } from 'react';
import API from '../../api/axios';
import AppLayout from '../../components/layout/AppLayout';
import { Page, PageHeader } from '../../components/ui';
import CommandesEnLigne from '../../components/commandes/CommandesEnLigne';

// Commandes WhatsApp / Messenger de tous les établissements du propriétaire
export default function CommandesProprietaire() {
  const [etablissements, setEtablissements] = useState([]);
  const [resume, setResume] = useState(null);

  useEffect(() => {
    API.get('/etablissements')
      .then(r => setEtablissements(r.data.etablissements || []))
      .catch(() => {});
  }, []);

  const aTraiter = (Number(resume?.nouvelles) || 0) + (Number(resume?.non_lus) || 0);

  return (
    <AppLayout role="proprietaire" badges={{ '/proprietaire/commandes': aTraiter }}>
      <Page>
        <PageHeader
          title="Commandes en ligne"
          subtitle="Commandes reçues sur WhatsApp et Messenger pour vos établissements"
        />
        <CommandesEnLigne etablissements={etablissements} onResume={setResume} />
      </Page>
    </AppLayout>
  );
}
